import React, { FC, useEffect, useState } from 'react';
import { Create } from 'react-admin';

import Breadcrumb from 'components/Breadcrumb';
import { getChallenge, getChallengeWeek } from 'services/challenge';
import { validateExerciseCreation } from './exerciseValidation';
import { useExerciseStyles } from './useExerciseStyles';
import { ExerciseForm } from '../components/exercises-form';

export const ExerciseCreate: FC<any> = props => {
  const [week, setWeek] = useState('Week');
  const [challenge, setChallenge] = useState('Challenge');
  const classes = useExerciseStyles();

  const urlParams = new URLSearchParams(props.location.search);
  const challengeId = urlParams.get('challengeId') || '';
  const weekId = urlParams.get('challengeWeekId') || '';

  useEffect(() => {
    const loadData = async () => {
      try {
        const [
          { data: challengeData },
          { data: challengeWeekData },
        ] = await Promise.all([
          getChallenge(challengeId),
          getChallengeWeek(weekId),
        ]);

        setChallenge(challengeData?.name || 'Challenge');
        setWeek(`Week ${challengeWeekData?.weekNumber || ''}`);
      } catch (error) {
        console.error(error);
      }
    };

    loadData();
  }, []);

  return (
    <>
      <Breadcrumb
        routes={[
          { text: 'Challenges', to: '/#/challenge' },
          { text: challenge, to: `/#/challenge/${challengeId}/show` },
          {
            text: week,
            to: `/#/challenge/${challengeId}/week/${weekId}/exercises`,
          },
          { text: 'New Exercise' },
        ]}
      />
      <Create {...props} className={classes.createBox}>
        <ExerciseForm {...props} validate={validateExerciseCreation()} />
      </Create>
    </>
  );
};
